import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { useInventorySummary } from 'Features/Projects/Scenarios/Inventory/Inventory.data'
import { useParams } from 'react-router-dom'
import { InventorySummaryTable } from 'Features/Projects/Scenarios/Inventory/Inventory.Summary.table'
import { Loader } from 'Common/Loader/Loader'
import { ErrorDisplay } from 'Common/Error/Error'

export const InventoryView = () => {
  const { projectId, scenarioId } = useParams<{
    projectId: string
    scenarioId: string
  }>() as { projectId: string; scenarioId: string }

  const { data, isLoading, isError, isRefetching, refetch } =
    useInventorySummary({
      projectId,
      scenarioId,
    })

  return (
    <SettingsPage title="Inventory summary">
      {isLoading && <Loader />}
      {isError && <ErrorDisplay />}
      {data && (
        <InventorySummaryTable
          data={data}
          isRefetching={isRefetching}
          handleRefetch={() => {
            refetch()
          }}
        />
      )}
    </SettingsPage>
  )
}
